exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-client__root--1UBE1{-ms-flex-direction:column;-webkit-box-direction:normal;-webkit-box-orient:vertical;display:-webkit-box;display:-ms-flexbox;display:flex;flex-direction:column;height:100%}.besidaMob-client__banText--3Kx7C{font-size:14px;padding:20px 40px}.besidaMob-client__unban--3ZfNc{background:#fff;border-top:1px solid #dfe1f0;padding:10px;position:relative}.besidaMob-client__unbanText--1YqVd{font-size:14px;margin:5px 15px 15px;text-align:center}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-client__root--1UBE1",
	"banText": "besidaMob-client__banText--3Kx7C",
	"unban": "besidaMob-client__unban--3ZfNc",
	"unbanText": "besidaMob-client__unbanText--1YqVd"
};